<script setup lang="ts">
import { BANNER_TONES, type BannerTone } from './variants'

withDefaults(defineProps<{ tone?: BannerTone }>(), { tone: 'info' })
</script>

<template>
  <div :role="tone === 'danger' ? 'alert' : 'status'"
       :class="[BANNER_TONES[tone], 'animate-rise-in rounded-input px-3 py-2 text-[13px] leading-[1.45]']">
    <slot />
  </div>
</template>
